// setup functional component, import it to App.jsx for rendering
import React from 'react'
import './intro.css';
import me from "../../img/me3.png"
// import CV from "../../img/CV.pdf"
import Git from "../../img/github.png";
import LinkedIn from "../../img/linkedin.png";


const Intro = () => {
  return (
    <div className="i">
        {/* splitting comp left, right with flexbox */}
        <div className="i-left">
            <div className="i-left-wrapper">
                <div className="i-socials">
                    <a href="http://github.com/Codexgrey" target="_blank" rel="noreferrer">
                        <img src={Git} alt="GitHub" className="i-social-icon" width="32" height="32" decoding="async" />
                    </a>

                    <a href="http://www.linkedin.com/in/collinsovuakporaye" target="_blank" rel="noreferrer">
                        <img src={LinkedIn} alt="LinkedIn" className="i-social-icon" width="32" height="32" decoding="async" />
                    </a>
                </div>

                <h2 className="i-intro">Hello, i'm</h2>
                <h1 className="i-name">Collins Ovuakporaye</h1>

                <div className="i-title">
                    <div className="i-title-wrapper">
                        <div className="i-title-item">Full Stack Engineer</div>
                        <div className="i-title-item">Software Engineer</div>
                    </div>
                </div>

                <p className="i-desc">
                    Building solutions end to end,<br />
                    from React interfaces to required backends.
                </p>
                <div className="i-actions">
                    <a 
                        className="cv"
                        href= "https://drive.google.com/file/d/1oaoSQLmDuW5tgRCis7C7Q_VjhqHZPgns/view?usp=drive_link"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Résumé
                    </a>
                    <a className="cv cv-outline" href="#work">Some Works</a>
                </div>
            </div>

            {/* SVG to indicate scroll */}
            <svg
                width="75"
                height="75"
                viewBox="0 0 75 75"
                fill="none"
                stroke="#59b256"
                className="i-scroll"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="scroll">
                    <path
                        id="Vector"
                        d="M40.5 15L34.5 9L28.5 15"
                        strokeWidth="3"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_2"
                        d="M28.5 24L34.5 30L40.5 24"
                        strokeWidth="3"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <g id="Group">
                    <path
                        id="Vector_3"
                        d="M9 37.5H60"
                        strokeWidth="3"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    </g>
                    <path
                        id="Vector_4"
                        d="M34.5 27V9"
                        strokeWidth="2.9895"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <g id="Group_2">
                        <path
                            id="Vector_5"
                            d="M9 27C9 12.918 20.418 1.5 34.5 1.5C48.5859 1.5 60 12.918 60 27C60 29.8906 60 45.1094 
                                60 48C60 62.082 48.5859 73.5 34.5 73.5C20.418 73.5 9 62.082 9 48C9 45.1094 9 29.8906 9 27Z"
                            strokeWidth="3"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                </g>
            </svg>
        </div>
         
         {/* Above the fold photo */}
        <div className="i-right">
            <div className="i-bg"></div>
            <div className="i-photo-card">
                <img src={me} alt="Illustrated portrait of Collins Ovuakporaye" className="i-img" decoding="async" fetchPriority="high" />
            </div>
        </div>
    </div>
  )
}

export default Intro